import React from 'react';
import { Helmet } from 'react-helmet';

const defaultTitle = 'Oldschool.gg';

const defaultDescription =
	'Old School Bot is a Old School RuneScape (OSRS) Discord Bot, Oldschool.gg is also the home of a Loot simulator, Clue simulator and other fun tools.';

const defaultKeywords = ['runescape bot', 'osrs bot', 'rs bot', 'discord', 'osrs', 'oldschool bot'];

const SEO = ({
	title,
	desc,
	keywords,
	image,
	url
}: {
	title?: string;
	desc?: string;
	keywords?: string[];
	image?: string;
	url?: string;
}) => (
	<Helmet>
		<title>{title ? `${title} - Oldschool.gg` : defaultTitle}</title>
		<meta name="og:title" content={title ? `${title} - Oldschool.gg` : defaultTitle} />
		<meta name="description" content={desc || defaultDescription} />
		<meta name="og:description" content={desc || defaultDescription} />
		<meta name="keywords" content={(keywords || defaultKeywords).join(', ')} />
		<meta name="og:url" content={url || 'https://www.oldschool.gg/'} />
		<meta name="og:image" content={image || 'https://www.oldschool.gg/logo.jpg'} />
	</Helmet>
);

export default SEO;
